import { Component, OnInit } from '@angular/core';
import { ConfirmationModalService } from './confirmation-modal.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent implements OnInit {
  showNewAppConfirmation: boolean = false;
  onHide = new Subject<void>();

  constructor(public confirmationModalService: ConfirmationModalService) {
    confirmationModalService.events.show.subscribe(() => {
      this.showNewAppConfirmation = true;
    });

    confirmationModalService.events.hide.subscribe(() => {
      this.showNewAppConfirmation = false;
    });
  }

  ngOnInit(): void {}

  accept(): void {
    this.confirmationModalService.accept();
    this.hide();
  }

  reject(): void {
    this.confirmationModalService.reject();
    this.hide();
  }

  hide(): void {
    this.showNewAppConfirmation = false;
    this.confirmationModalService.hide();
  }
}
